import { PostEffectsPipeline } from "./PostEffectsPipeline";
import { PostEffect } from "./PostEffect";
import { Quad } from "./Quad";
import * as fs from "fs";
import { FadePostEffect } from "./FadePostEffect";
import { BloomPostEffect } from "./BloomAddPostEffect";

export function createPostEffectsPipeline(
  gl: WebGL2RenderingContext,
  resolution: [number, number],
  bloomTexture: WebGLTexture,
) {
  const fxaa = new PostEffect(
    gl,
    "FXAA",
    fs.readFileSync(__dirname + "/effects/fxaa.frag", "utf8"),
  );

  const bloomAdd = new BloomPostEffect(gl, bloomTexture);

  const tonemapExposure = new PostEffect(
    gl,
    "Tonemap Exposure",
    fs.readFileSync(__dirname + "/effects/tonemap_exposure.frag", "utf8"),
  );

  const chromaticAberration = new PostEffect(
    gl,
    "Chromatic Aberration",
    fs.readFileSync(__dirname + "/effects/chromatic_aberration.frag", "utf8"),
  );

  const boxBlur = new PostEffect(
    gl,
    "Box Blur",
    fs.readFileSync(__dirname + "/effects/box_blur.frag", "utf8"),
  );

  const vhsDistortion = new PostEffect(
    gl,
    "VHS Distortion",
    fs.readFileSync(__dirname + "/effects/vhs_distortion.frag", "utf8"),
  );
  vhsDistortion.enabled = false;

  const fade = new FadePostEffect(gl);

  const vignette = new PostEffect(
    gl,
    "Vignette",
    fs.readFileSync(__dirname + "/effects/vignette.frag", "utf8"),
  );

  const noise = new PostEffect(
    gl,
    "Noise",
    fs.readFileSync(__dirname + "/effects/noise.frag", "utf8"),
  );

  const effects = [
    bloomAdd,
    fxaa,
    tonemapExposure,
    chromaticAberration,
    //boxBlur,
    vhsDistortion,
    fade,
    vignette,
    noise,
  ];
  const quad = new Quad(gl);

  return new PostEffectsPipeline(gl, quad, resolution, 1.0, true, effects);
}

export function createBloomPipeline(
  gl: WebGL2RenderingContext,
  resolution: [number, number],
) {
  const bloomExtract = new PostEffect(
    gl,
    "Bloom Extract",
    fs.readFileSync(__dirname + "/effects/bloom_extract.frag", "utf8"),
  );

  const bloomBlur = new PostEffect(
    gl,
    "Bloom Blur",
    fs.readFileSync(__dirname + "/effects/box_blur.frag", "utf8"),
  );

  return new PostEffectsPipeline(gl, new Quad(gl), resolution, 1.0, false, [
    bloomExtract,
    bloomBlur,
    bloomBlur,
    bloomBlur,
    bloomBlur,
    bloomBlur,
  ]);
}
